<template>
  <div style="height:100%">
      <div class="toolbar">
            <el-button type="primary" size="small" class="marker-panel" @click="AdSgn(viewer)">
                {{msg}}
           </el-button>
        </div>
       <markview ref='mak'></markview>
       <el-dialog  :visible.sync="editVisible" width="13%" class="edit" style="margin-top: 5vh;">
            <el-button type="primary" size="mini" @click="edit()">编辑</el-button>
            <el-button type="danger" size="mini" @click="dele()">删除</el-button>
       </el-dialog>
    <div id="cesiumContainer"></div>
 </div>
</template>
<script>
import util from '../../components/util.js';
import markview from './markview.vue';
import convertTool from '../../js/Convert';
import {createCursor} from '../../js/drawhandler';

export default {
    data () {
        return {
            msg:'添加标记',
            viewer:null,
            scenePos: '',
            isShow: false,
            billboards: undefined,
            labels: undefined,
            editVisible:false
        }
    },
    mounted () {
      this.init();
      this.billboards = this.viewer.scene.primitives.add(new Cesium.BillboardCollection());
      this.labels = this.viewer.scene.primitives.add(new Cesium.LabelCollection());
      this.upiconn();
    },
    components:{markview},

    methods : {
      init () {
          this.viewer=util.getViewer('cesiumContainer',{
              fullscreenButton: false,
          });
         this.viewer.scene.camera.setView({
             destination: new Cesium.Cartesian3.fromDegrees(-75.1705217, 39.921786,100),
             orientation: new Cesium.HeadingPitchRoll(5.646733805039757, -0.276607153839886, 6.281110875400085)
         })
      },
      //点击添加图标
      AdSgn() {
         createCursor(this.viewer,'点击地图添加标记');
         var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
         handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
         handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
         handler.setInputAction((event)=>{
            const e = window.event,//event|| window.event,
            target = e.target || e.srcElement;
             if (target && target.tagName == 'CANVAS' && target.parentElement.className == 'cesium-widget') {
                if(document.getElementById('cursortip')){
                    document.body.removeChild(document.getElementById('cursortip'))
                };
                this.scenePos = event.position;
                const cvt = convertTool(this.viewer);
                this.id = "marker" + Math.round(Math.random() * 10000);
                this.scenePos=event.position;
                this.billboards.add({
                id: this.id,
                position: cvt.screenWorld(this.scenePos),
                image: this.$refs.mak.defaimag,
                });
                this.labels.add({
                position: cvt.screenWorld(this.scenePos),
                id: this.id,
                text: '',
                font: '24px sans-serif',
                fillColor: Cesium.Color.BLACK,
                outlineWidth: 5,
                outlineColor: Cesium.Color.WHITE,
                pixelOffset: new Cesium.Cartesian2(20, 20),
                style: Cesium.LabelStyle.FILL_AND_OUTLINE
                });
                this.$refs.mak.form.name='';
             }
             handler.destroy();
             this.$refs.mak.dialogFormVisible=true;
            },Cesium.ScreenSpaceEventType.LEFT_CLICK);
      },
    //监听图标点击事件
    upiconn() {
            var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
            handler.setInputAction((event)=>{
            var pick = this.viewer.scene.pick(event.position);
                console.log(pick)
            //选中   pick选中的对象
            if(pick && pick.id){
                this.editVisible=true;
            }
         }, Cesium.ScreenSpaceEventType.RIGHT_CLICK  );
      },
      edit () {
          this.editVisible=false;
          this.$refs.mak.dialogFormVisible=true;
      },
      dele () {
          this.editVisible=false;
        //   this.$refs.mak.dele();
      }
    }
}
</script>
<style lang='stylus' scoped>
 #cesiumContainer 
        height: 100%;

.edit>>>.el-dialog__header
    display: none;

</style>

